var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-input',{staticClass:"w-full",attrs:{"type":"file","accept":_vm.acceptedTypes,"multiple":_vm.isMultiple,"disabled":_vm.isDisabled},on:{"change":function($event){return _vm.handleFileSelection($event)}},model:{value:(_vm.selectedFile),callback:function ($$v) {_vm.selectedFile=$$v},expression:"selectedFile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }